import React, {useState} from 'react';
import { useSelector } from 'react-redux';
import { Tooltip } from 'reactstrap';

export const ThinkingTalentsReportUserItem = ({ item, color }) => {

    const [tooltipOpen, setTooltipOpen] = useState(false);

    const toggle = () => setTooltipOpen(!tooltipOpen);

    const { talents } = useSelector(state => state.user);

    const hasItemUser = talents.filter(talent => talent.items.find(i => i.name === item.item.name)).length > 0;

    const backgroundColorReferences = hasItemUser && item.item.energy_level === 1 ? "border-always bg-always" :
        !hasItemUser && item.item.energy_level === 3 && "border-never bg-never";

    return (
        <div className="talents-item text-center mb-2 p-2" >
            <div>
                <div id={`talent-${item.item.id}`} className={`rounded-circle border mx-auto d-inline-block p-2 ${backgroundColorReferences ? backgroundColorReferences : 'border-primary'}`}>
                    <img src={item.item.icon_invert} className="d-block" width="30" height="30" alt={item.name}/>
                </div>
                <Tooltip placement="auto" isOpen={tooltipOpen} target={`#talent-${item.item.id}`} toggle={toggle}>
                    <p><span className='font-weight-bold text-shadow'>Description: </span>{item.item.light_talent}</p>
                    <p className='mb-0'><span className='font-weight-bold text-shadow'>Shadow talent: </span>{item.item.shadow_talent}</p>
                </Tooltip>

                <p className="mb-0 small font-weight-semibold">{item.item.name}</p>
                
            </div>
        </div>
    )
}
